import { getAreGatesPopulated, getIsUngated, getIsUngatedForBreezeIntelligence, getIsUngatedForCheckoutInterstitialUI, getIsUngatedForMTVTrialPurchaseMotion, getIsUngatedForMarketingPlus, getIsUngatedForRecommendedView, getIsUngatedForSeats, getIsUngatedForUnifiedCartExperiment } from 'pricing-pages-lib/utils/gatingUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
import { productDataIsEmptySelector } from './ProductsSelectors';
import { HUBSPOT_CREDITS_COMMITTED } from 'self-service-api/constants/ApiNames';
import { HUBSPOT_CREDITS_COMMITTED_OVERAGE } from 'self-service-api/constants/UpgradeProducts';
export const isUngatedSelector = createSelectorFromUtil(getIsUngated, transformState);
export const areGatesPopulatedSelector = createSelectorFromUtil(getAreGatesPopulated, transformState);
export const isUngatedForSeatsSelector = createSelectorFromUtil(getIsUngatedForSeats, transformState);
export const isUngatedForMarketingPlusSelector = createSelectorFromUtil(getIsUngatedForMarketingPlus, transformState);
export const isUngatedForBreezeIntelligenceSelector = createSelectorFromUtil(getIsUngatedForBreezeIntelligence, transformState);
export const isUngatedForCheckoutInterstitialUISelector = createSelectorFromUtil(getIsUngatedForCheckoutInterstitialUI, transformState);
export const isUngatedForUnifiedCartExperimentSelector = createSelectorFromUtil(getIsUngatedForUnifiedCartExperiment, transformState);
export const isUngatedForMTVTrialPurchaseMotionSelector = createSelectorFromUtil(getIsUngatedForMTVTrialPurchaseMotion, transformState);
export const isUngatedForRecommendedViewSelector = createSelectorFromUtil(getIsUngatedForRecommendedView, transformState);
export const isUngatedForHubSpotCreditsSelector = state => {
  if (productDataIsEmptySelector(state)) return false;
  const {
    abstractedProducts: {
      apiNameToProductId
    }
  } = state;
  const apiNames = [HUBSPOT_CREDITS_COMMITTED, HUBSPOT_CREDITS_COMMITTED_OVERAGE];
  return apiNames.some(apiName => {
    return apiNameToProductId === null || apiNameToProductId === void 0 ? void 0 : apiNameToProductId[apiName];
  });
};